import React from "react";
import QRCodeGenerator from "./QRCodeGenerator"; // Importa el componente de QR
import { useQRCodeHandlers } from "../utils/qrCodeUtils"; // Importa las funciones de utilidades
import "./LanguageModal.css";
import "./ProfileCard.css"; // Importa el CSS de ProfileCard para reutilizar los estilos

const flagUrls = {
  es: "https://cdn-icons-png.flaticon.com/512/197/197593.png",
  en: "https://cdn-icons-png.flaticon.com/512/197/197374.png",
  de: "https://cdn-icons-png.flaticon.com/512/197/197571.png",
  fr: "https://cdn-icons-png.flaticon.com/512/197/197560.png",
  it: "https://cdn-icons-png.flaticon.com/512/197/197626.png",
  pt: "https://cdn-icons-png.flaticon.com/512/197/197463.png",
  nl: "https://cdn-icons-png.flaticon.com/512/197/197441.png",
  ru: "https://cdn-icons-png.flaticon.com/512/197/197408.png",
};

const LanguageModal = ({ title, icon, links, onClose }) => {
  const {
    showQRCode,
    selectedLink,
    selectedLanguage,
    handleQRCodeClick,
    handleCloseQRCode,
  } = useQRCodeHandlers(links);

  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
    <div className="modal-overlay" onClick={onClose}>
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <h2>
          <i className={icon} /> {title}
        </h2>
        <div className="flags">
          {Object.entries(links).map(([language, url]) => (
            // biome-ignore lint/a11y/useButtonType: <explanation>
            <button
              key={language}
              onClick={() => handleQRCodeClick(url, language)}
              className="flag-link"
            >
              <img
                src={flagUrls[language]}
                alt={language}
                className="flag-icon"
              />
            </button>
          ))}
        </div>
        {showQRCode && (
          // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
          <div onClick={handleCloseQRCode}>
            {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
            <div onClick={(e) => e.stopPropagation()}>
              <QRCodeGenerator value={selectedLink} size={256} />
              {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
              <button
                className="full-width-button"
                onClick={() => window.open(selectedLink, "_blank")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i className={icon} style={{ marginRight: 8 }} />
                {title}
                {flagUrls[selectedLanguage] && (
                  <img
                    src={flagUrls[selectedLanguage]}
                    alt={selectedLanguage}
                    style={{ width: 20, height: 20, marginLeft: 8 }}
                  />
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageModal;
